package ru.villawonka.app.domain.model

abstract class PostDomain {
    abstract val id: Int
    abstract val city: String
    abstract val district: String
    abstract val country: CountryDomain
    abstract val description: String
    abstract val media: List<String>
    abstract val isLiked: Boolean
    abstract val isNew: Boolean
    abstract val updatedAt: String
    abstract val createdAt: String
    abstract val source: PostSourceDomain?

    data class Accommodation(
        override val id: Int,
        override val city: String,
        override val district: String,
        override val country: CountryDomain,
        override val description: String,
        override val media: List<String>,
        override val isLiked: Boolean,
        override val isNew: Boolean,
        override val source: PostSourceDomain?,
        override val updatedAt: String,
        override val createdAt: String,

        val rentType: RentTypeDomain,
        val rentFrom: String?,
        val rentTo: String?,

        val originalCost: Int,
        val originalDeposit: Int?,
        val originalCurrency: CurrencyDomain,

        val displayCost: Int?,
        val displayDeposit: Int?,
        val displayCurrency: CurrencyDomain?,

        val costConversationDetails: ConversationDetailsDomain?,

        val accommodationType: AccommodationTypeDomain,
        val additions: List<AccommodationAdditionDomain>?,
        val bedrooms: Int?,
        val bathrooms: Int?,

        val mentionedUsernames: List<String>?,
        val mentionedPhoneNumbers: List<String>?,

        val contactUserId: Long,
        val contactUsername: String?,
    ) : PostDomain()
}

fun PostDomain.groupId() = media.first()

fun PostDomain.getContactUsername(): String? = when (this) {
    is PostDomain.Accommodation -> contactUsername ?: mentionedUsernames?.firstOrNull()
    else -> null
}

fun PostDomain.getPhoneNumber(): String? = when (this) {
    is PostDomain.Accommodation -> mentionedPhoneNumbers?.firstOrNull()
    else -> null
}
